import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const RATE_API_PREFIX = 'v2';
const {
    ajaxCommon,
    ajaxv2Common
} = Ajax;
const TheApi = API(RATE_API_PREFIX + '/quality');

const QUALITY_CURRENT_LIST = `QUALITY_CURRENT_LIST`;
const QUALITY_HISTORY_LIST = `QUALITY_HISTORY_LIST`;
const QUALITY_UPDATE_PERSON = `QUALITY_UPDATE_PERSON`;
const QUALITY_ADD_PERSON = `QUALITY_ADD_PERSON`;
const QUALITY_DELETE_PERSON = `QUALITY_DELETE_PERSON`;
const QUALITY_REMOVE_PERSON = `QUALITY_REMOVE_PERSON`;
const QUALITY_CHECK_PERSON = `QUALITY_CHECK_PERSON`;

export default {
  QUALITY_CURRENT_LIST,
  qualityCurrentList:(params)=>{
    return ajaxCommon({
      data:params,
      api: TheApi(`get`)('currentlist'),
      success:(data)=>({
        type:QUALITY_CURRENT_LIST,
        data:data.data
      })
    })
  },
  QUALITY_HISTORY_LIST,
  qualityHistoryList: (consumerid)=>{
    return ajaxCommon({
      data:{
        consumerid
      },
      api: TheApi(`get`)('historylist'),
      success:(data)=>({
        type:QUALITY_HISTORY_LIST,
        data:data.data
      })
    })
  },
  QUALITY_UPDATE_PERSON,
  qualityUpdatePerson:(person)=>{
    if(typeof person.permission == 'object' || person.permission instanceof Array) {
      person.permission = JSON.stringify(person.permission);
    }
    return ajaxCommon({
      data:person,
      api: TheApi(`post`)('updateperson'),
      success:(data)=>({
        type:QUALITY_UPDATE_PERSON,
        data:data.data
      })
    })
  },
  QUALITY_ADD_PERSON,
  qualityAddPerson:(person)=>{
    if(typeof person.permission == 'object' || person.permission instanceof Array) {
      person.permission = JSON.stringify(person.permission);
    }
    return ajaxCommon({
      data:person,
      api: TheApi(`post`)('addperson'),
      success:(data)=>({
        type:QUALITY_ADD_PERSON,
        data:data.data
      })
    })
  },
  QUALITY_DELETE_PERSON,
  qualityDeletePerson:(id)=>{
    return ajaxCommon({
      data:{id},
      api: TheApi(`post`)('deleteperson'),
      success:(data)=>({
        type:QUALITY_DELETE_PERSON,
        data:data.data
      })
    })
  },
  QUALITY_REMOVE_PERSON,
  qualityRemovePerson:(id)=>{
    return ajaxCommon({
      data:{id},
      api: TheApi(`post`)('removeperson'),
      success:(data)=>({
        type:QUALITY_REMOVE_PERSON,
        data:data.data
      })
    })
  },
  QUALITY_CHECK_PERSON,
  qualityCheckPerson:(id,orderid)=>{
    return ajaxCommon({
      data:{id,orderid},
      api: TheApi(`post`)('checkperson'),
      success:(data)=>({
        type:QUALITY_CHECK_PERSON,
        data:data.data
      })
    })
  },
};


// WEBPACK FOOTER //
// ./src/actions/QualityAction.js